export const UNSAVED_CHANGES_LEAVE_MESSAGE =
  'Modifiche non salvate. Lasciando la pagina le modifiche verranno perse. Procedere comunque?';

export const UNSAVED_CHANGES_CLOSE_MESSAGE =
  'Modifiche non salvate. Chiudendo la finestra le modifiche verranno perse. Procedere comunque?';
